import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStep6 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 484 450",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9561 399.525H1.35059V399.793H14.9561V399.525Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.666 84.407H5.51074V316.243H147.666V84.407Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.009 84.407H7.53711V316.243H152.009V84.407Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.666 316.243H5.51074V322.811H147.666V316.243Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M159.234 316.243H14.7627V322.811H159.234V316.243Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M145.929 310.168V90.4714L13.6047 90.4714V310.168H145.929Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4424 310.168L60.3501 90.4714H86.7248L69.8171 310.168H43.4424Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4244 304.125C16.3672 304.126 16.3103 304.116 16.257 304.095C16.2037 304.075 16.1552 304.043 16.1142 304.003C16.0733 303.963 16.0407 303.916 16.0185 303.863C15.9963 303.81 15.9848 303.754 15.9849 303.696V94.4249C15.975 94.3622 15.9788 94.2981 15.9961 94.237C16.0133 94.176 16.0437 94.1194 16.0849 94.0711C16.1262 94.0229 16.1774 93.9841 16.2351 93.9576C16.2928 93.931 16.3556 93.9172 16.4191 93.9172C16.4826 93.9172 16.5454 93.931 16.603 93.9576C16.6607 93.9841 16.712 94.0229 16.7532 94.0711C16.7945 94.1194 16.8248 94.176 16.8421 94.237C16.8594 94.2981 16.8632 94.3622 16.8533 94.4249V303.696C16.8533 303.753 16.8422 303.808 16.8206 303.86C16.7991 303.912 16.7675 303.96 16.7277 303.999C16.6879 304.039 16.6406 304.071 16.5886 304.092C16.5365 304.114 16.4807 304.125 16.4244 304.125Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.4893 310.168L92.3862 90.4714H102.668L85.7711 310.168H75.4893Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M145.929 310.168V90.4714H145.157V310.168H145.929Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M153.446 99.6212H11.2899L10.7217 92.8284H152.888L153.446 99.6212Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M153.446 110.764H11.2899L10.7217 103.971H152.888L153.446 110.764Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M153.446 121.896H11.2899L10.7217 115.104H152.888L153.446 121.896Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M153.446 133.039H11.2899L10.7217 126.246H152.888L153.446 133.039Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M153.446 144.171H11.2899L10.7217 137.378H152.888L153.446 144.171Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M153.446 155.314H11.2899L10.7217 148.521H152.888L153.446 155.314Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M482.486 225.107H433.972L438.271 168.375H478.187L482.486 225.107Z",
			fill: "#FDD400"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M471.839 225.107H463.498L461.729 168.375H469.427L471.839 225.107Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M460.658 225.107H455.801V382.928H460.658V225.107Z",
			fill: "#FDD400"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M460.615 295.779H455.844C454.659 295.779 453.699 296.738 453.699 297.921V302.689C453.699 303.873 454.659 304.832 455.844 304.832H460.615C461.799 304.832 462.759 303.873 462.759 302.689V297.921C462.759 296.738 461.799 295.779 460.615 295.779Z",
			fill: "#FFE511"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M460.615 310.285H455.844C454.659 310.285 453.699 311.245 453.699 312.428V317.196C453.699 318.38 454.659 319.339 455.844 319.339H460.615C461.799 319.339 462.759 318.38 462.759 317.196V312.428C462.759 311.245 461.799 310.285 460.615 310.285Z",
			fill: "#FFE511"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M465.911 382.928H450.547C450.547 382.07 450.884 381.245 451.485 380.632C452.086 380.019 452.904 379.666 453.763 379.65H462.587C463.446 379.666 464.264 380.019 464.865 380.632C465.467 381.245 465.804 382.07 465.804 382.928H465.911Z",
			fill: "#FFBF1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M460.658 225.107H455.801V228.075H460.658V225.107Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256.027 438.814C370.835 438.814 463.906 433.384 463.906 426.686C463.906 419.987 370.835 414.557 256.027 414.557C141.22 414.557 48.1494 419.987 48.1494 426.686C48.1494 433.384 141.22 438.814 256.027 438.814Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M364.193 379.725H399.638V275.368H364.193V379.725Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M166.908 382.929H397.247V379.725H166.908V382.929Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M364.193 275.368H164.517V379.726H364.193V275.368Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M350.244 316.5H178.443V338.593H350.244V316.5Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M350.244 344.947H178.443V367.04H350.244V344.947Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225.875 320.358H302.823C303.455 320.355 304.061 320.102 304.507 319.654C304.953 319.206 305.203 318.6 305.203 317.968C305.2 317.338 304.949 316.735 304.503 316.29C304.057 315.844 303.453 315.593 302.823 315.59H225.875C225.245 315.593 224.641 315.844 224.195 316.29C223.75 316.735 223.498 317.338 223.495 317.968C223.495 318.6 223.746 319.206 224.192 319.654C224.638 320.102 225.243 320.355 225.875 320.358Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M350.244 288.065H178.443V310.158H350.244V288.065Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225.875 291.868H302.823C303.453 291.865 304.057 291.614 304.503 291.168C304.949 290.723 305.2 290.119 305.203 289.489C305.203 288.858 304.953 288.251 304.507 287.804C304.061 287.356 303.455 287.103 302.823 287.1H225.875C225.243 287.103 224.638 287.356 224.192 287.804C223.746 288.251 223.495 288.858 223.495 289.489C223.498 290.119 223.75 290.723 224.195 291.168C224.641 291.614 225.245 291.865 225.875 291.868Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225.875 348.751H302.823C303.453 348.748 304.057 348.496 304.503 348.051C304.949 347.605 305.2 347.002 305.203 346.372C305.203 345.74 304.953 345.134 304.507 344.686C304.061 344.238 303.455 343.985 302.823 343.983H225.875C225.243 343.985 224.638 344.238 224.192 344.686C223.746 345.134 223.495 345.74 223.495 346.372C223.498 347.002 223.75 347.605 224.195 348.051C224.641 348.496 225.245 348.748 225.875 348.751Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M161.375 275.379H364.192V272.4H161.375V275.379Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403.004 272.39H364.182V275.368H403.004V272.39Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.2686 45.9338H254.418V194.357C254.418 195.79 253.446 197.165 251.716 198.178C249.987 199.192 247.641 199.761 245.195 199.761H81.3761C78.93 199.761 76.5842 199.192 74.8546 198.178C73.125 197.165 72.1533 195.79 72.1533 194.357V45.9338H72.2686Z",
			fill: "#EDF3F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.2349 20.1734H242.359C245.539 20.1734 248.588 21.4358 250.837 23.6827C253.085 25.9297 254.348 28.9773 254.348 32.155V45.9799H72.1992V32.155C72.1992 30.5777 72.5109 29.0159 73.1163 27.5592C73.7217 26.1025 74.6089 24.7796 75.7272 23.6664C76.8454 22.5532 78.1725 21.6716 79.6325 21.0722C81.0925 20.4728 82.6565 20.1674 84.2349 20.1734Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173.202 106.192V97.1189L168.529 96.6747C167.916 93.658 166.732 90.7864 165.039 88.2152L168.042 84.5776L161.697 78.233L158.081 81.2361C155.507 79.5495 152.636 78.3654 149.621 77.7465L149.156 72.988H140.083L139.682 77.7465C136.667 78.3654 133.796 79.5495 131.222 81.2361L127.606 78.233L121.261 84.5776L124.264 88.2152C122.571 90.7864 121.387 93.658 120.774 96.6747L116.101 97.1189V106.192L120.774 106.636C121.393 109.651 122.577 112.521 124.264 115.095L121.261 118.733L127.606 125.078L131.222 122.074C133.796 123.761 136.667 124.945 139.682 125.564L140.126 130.238H149.198L149.643 125.564C152.657 124.945 155.528 123.761 158.102 122.074L161.719 125.078L168.063 118.733L165.06 115.032C166.747 112.458 167.931 109.587 168.55 106.572L173.202 106.192ZM144.63 113.953C142.194 113.958 139.811 113.239 137.784 111.888C135.757 110.537 134.176 108.615 133.242 106.365C132.307 104.115 132.062 101.638 132.536 99.2486C133.01 96.859 134.183 94.6639 135.906 92.9412C137.628 91.2185 139.824 90.0458 142.213 89.5716C144.603 89.0973 147.079 89.3429 149.329 90.2771C151.579 91.2113 153.501 92.7922 154.852 94.8196C156.203 96.847 156.922 99.2296 156.918 101.666C156.912 104.923 155.616 108.045 153.313 110.348C151.01 112.651 147.887 113.948 144.63 113.953Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.999 131.845V124.718L206.34 124.379C205.857 122.034 204.931 119.801 203.612 117.802L205.96 114.968L201.011 109.935L198.177 112.282C196.177 110.963 193.945 110.038 191.6 109.554L191.261 105.874H184.092L183.753 109.554C181.408 110.038 179.175 110.963 177.176 112.282L174.342 109.935L169.287 114.968L171.635 117.802C170.316 119.801 169.39 122.034 168.907 124.379L165.248 124.718V131.845L168.907 132.183C169.39 134.529 170.316 136.761 171.635 138.76L169.287 141.594L174.321 146.628L177.155 144.28C179.154 145.599 181.386 146.525 183.732 147.008L184.071 150.667H191.198L191.536 147.008C193.882 146.525 196.114 145.599 198.113 144.28L200.947 146.628L205.981 141.594L203.633 138.76C204.952 136.761 205.878 134.529 206.361 132.183L209.999 131.845ZM187.602 137.914C185.695 137.914 183.83 137.349 182.245 136.289C180.659 135.23 179.423 133.723 178.693 131.961C177.963 130.199 177.772 128.26 178.144 126.389C178.516 124.518 179.434 122.8 180.783 121.451C182.132 120.103 183.85 119.184 185.721 118.812C187.592 118.44 189.531 118.631 191.293 119.361C193.055 120.091 194.561 121.327 195.621 122.913C196.681 124.499 197.246 126.363 197.246 128.271C197.246 130.828 196.23 133.281 194.422 135.09C192.613 136.898 190.16 137.914 187.602 137.914Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173.201 152.042V146.057L170.114 145.782C169.712 143.813 168.936 141.939 167.829 140.262L169.796 137.872L165.567 133.643L163.177 135.609C161.496 134.51 159.623 133.735 157.657 133.325L157.361 130.238H151.376L151.08 133.325C149.113 133.735 147.241 134.51 145.56 135.609L143.17 133.643L138.94 137.872L140.907 140.262C139.8 141.939 139.025 143.813 138.623 145.782L135.535 146.057V152.042L138.623 152.338C139.033 154.305 139.807 156.177 140.907 157.858L138.94 160.248L143.17 164.478L145.56 162.511C147.244 163.608 149.115 164.389 151.08 164.816L151.376 167.882H157.361L157.657 164.816C159.622 164.389 161.492 163.608 163.177 162.511L165.567 164.478L169.796 160.248L167.829 157.858C168.929 156.177 169.704 154.305 170.114 152.338L173.201 152.042ZM154.485 157.139C152.881 157.143 151.312 156.671 149.976 155.783C148.641 154.894 147.6 153.629 146.984 152.148C146.368 150.667 146.206 149.037 146.518 147.464C146.83 145.891 147.602 144.445 148.736 143.311C149.87 142.177 151.315 141.405 152.888 141.094C154.462 140.782 156.092 140.944 157.573 141.559C159.054 142.175 160.319 143.217 161.207 144.552C162.096 145.887 162.568 147.456 162.563 149.06C162.563 151.203 161.712 153.258 160.197 154.773C158.682 156.288 156.627 157.139 154.485 157.139Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M235.088 136.572H373.473V249.335C373.473 250.423 372.735 251.468 371.421 252.237C370.107 253.007 368.325 253.44 366.466 253.44H242.007C240.149 253.44 238.366 253.007 237.052 252.237C235.738 251.468 235 250.423 235 249.335V136.572H235.088Z",
			fill: "#F3F7F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.18 117H364.313C366.729 117 369.046 117.959 370.754 119.666C372.462 121.373 373.422 123.689 373.422 126.103V136.606H235.036V126.103C235.036 124.905 235.273 123.718 235.733 122.611C236.193 121.505 236.867 120.5 237.716 119.654C238.566 118.808 239.574 118.138 240.683 117.683C241.793 117.228 242.981 116.995 244.18 117Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M316.317 193.454H291.577V213.174H316.317V193.454Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M316.317 160.826H309.684V180.546H316.317V160.826Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M281 151V223H327.073V151H281ZM306.098 159.034C306.098 158.048 306.905 157.241 307.891 157.241H318.109C319.095 157.241 319.902 158.048 319.902 159.034V182.339C319.902 183.325 319.095 184.132 318.109 184.132H307.891C306.905 184.132 306.098 183.325 306.098 182.339V159.034ZM287.992 159.034C287.992 158.048 288.798 157.241 289.784 157.241H300.003C300.989 157.241 301.796 158.048 301.796 159.034V182.339C301.796 183.325 300.989 184.132 300.003 184.132H289.784C288.798 184.132 287.992 183.325 287.992 182.339V159.034ZM320.081 214.966C320.081 215.952 319.275 216.759 318.289 216.759H289.784C288.798 216.759 287.992 215.952 287.992 214.966V191.661C287.992 190.675 288.798 189.868 289.784 189.868H318.289C319.275 189.868 320.081 190.675 320.081 191.661V214.966ZM325.28 188.864C325.28 189.85 324.473 190.657 323.487 190.657C322.501 190.657 321.695 189.85 321.695 188.864V182.339C321.695 181.353 322.501 180.546 323.487 180.546C324.473 180.546 325.28 181.353 325.28 182.339V188.864Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M298.497 160.28H292.232V178.905H298.497V160.28Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M194.068 16.1533H301.214V103.461C301.214 104.304 300.643 105.113 299.625 105.709C298.608 106.305 297.228 106.64 295.789 106.64H199.425C197.986 106.64 196.606 106.305 195.589 105.709C194.572 105.113 194 104.304 194 103.461V16.1533H194.068Z",
			fill: "#F3F7F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.108 1.00005H294.122C295.993 1.00005 297.787 1.7426 299.109 3.06435C300.432 4.38611 301.175 6.17879 301.175 8.04803V16.1803H194.028V8.04803C194.028 7.12019 194.212 6.20148 194.568 5.34461C194.924 4.48774 195.446 3.70958 196.104 3.05476C196.761 2.39994 197.542 1.88135 198.401 1.52875C199.26 1.17616 200.18 0.996484 201.108 1.00005Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M221.212 83.8089C220.529 83.1265 219.988 82.3163 219.618 81.4246C219.249 80.533 219.059 79.5772 219.059 78.612C219.059 77.6468 219.249 76.6911 219.618 75.7994C219.988 74.9077 220.529 74.0976 221.212 73.4152L238.424 56.2821C238.807 55.8954 239.263 55.5884 239.765 55.3789C240.267 55.1694 240.806 55.0615 241.35 55.0615C241.894 55.0615 242.433 55.1694 242.936 55.3789C243.438 55.5884 243.894 55.8954 244.276 56.2821L248.805 60.7971C249.192 61.1811 249.499 61.638 249.709 62.1413C249.918 62.6447 250.026 63.1846 250.026 63.7298C250.026 64.2751 249.918 64.815 249.709 65.3183C249.499 65.8217 249.192 66.2786 248.805 66.6626L231.658 83.8089C230.977 84.5027 230.164 85.0537 229.267 85.4299C228.37 85.8061 227.407 85.9998 226.435 85.9998C225.462 85.9998 224.5 85.8061 223.603 85.4299C222.706 85.0537 221.893 84.5027 221.212 83.8089Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M252.803 55.5937L249.427 52.2174L268.797 32.8467L273.021 31.9993L272.174 36.223L252.803 55.5937Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M250.897 60.0821L244.938 54.1107C244.808 53.987 244.705 53.8381 244.634 53.6731C244.563 53.5081 244.526 53.3304 244.526 53.1508C244.526 52.9712 244.563 52.7935 244.634 52.6285C244.705 52.4634 244.808 52.3145 244.938 52.1908C245.062 52.0586 245.212 51.9531 245.378 51.881C245.545 51.8089 245.724 51.7717 245.905 51.7717C246.086 51.7717 246.266 51.8089 246.432 51.881C246.598 51.9531 246.748 52.0586 246.872 52.1908L252.83 58.149C252.962 58.2729 253.068 58.4226 253.14 58.5888C253.212 58.7551 253.249 58.9344 253.249 59.1156C253.249 59.2968 253.212 59.4761 253.14 59.6424C253.068 59.8086 252.962 59.9583 252.83 60.0821C252.706 60.2144 252.556 60.3199 252.39 60.392C252.224 60.4641 252.044 60.5013 251.863 60.5013C251.682 60.5013 251.503 60.4641 251.336 60.392C251.17 60.3199 251.021 60.2144 250.897 60.0821Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.872 48.6425L234.703 40.4467C236.226 36.3554 233.141 31.324 229.791 30L229.725 36.3024C229.725 37.0047 229.446 37.6783 228.949 38.1749C228.453 38.6715 227.779 38.9505 227.077 38.9505C226.374 38.9505 225.701 38.6715 225.204 38.1749C224.708 37.6783 224.429 37.0047 224.429 36.3024V30.1059C222.892 30.7287 221.565 31.7772 220.603 33.1281C219.641 34.479 219.085 36.0764 219 37.7324C219.02 39.6874 219.747 41.5691 221.046 43.0296C222.346 44.49 224.131 45.4303 226.07 45.6766C227.42 45.884 228.801 45.6906 230.043 45.1205L238.278 53.3826L242.872 48.6425Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M270.068 79.7309V85.9937C271.605 85.3709 272.932 84.3224 273.894 82.9715C274.855 81.6205 275.411 80.0232 275.497 78.3672C275.509 76.4202 274.82 74.5338 273.556 73.0531C272.292 71.5724 270.536 70.5964 268.612 70.3038C267.345 70.0414 266.029 70.1707 264.838 70.6745L256.285 62.0947L251.598 66.7818L260.098 75.2954C257.635 80.3268 261.422 84.5637 264.825 85.8877V79.6647C264.825 78.9624 265.104 78.2889 265.6 77.7923C266.097 77.2957 266.771 77.0166 267.473 77.0166C267.822 77.0235 268.166 77.0993 268.485 77.2396C268.805 77.3799 269.094 77.582 269.335 77.8342C269.576 78.0865 269.765 78.3839 269.891 78.7094C270.017 79.0349 270.077 79.3821 270.068 79.7309Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M377.308 420.247H369.46L369.471 402.064H377.33L377.308 420.247Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M440.415 405.236L432.899 407.507L424.622 391.018L432.138 388.746L440.415 405.236Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M429.993 408.868C429.496 409.06 428.948 409.079 428.439 408.922C428.273 408.844 428.13 408.726 428.023 408.578C427.916 408.43 427.849 408.257 427.828 408.075C427.802 407.968 427.805 407.856 427.837 407.751C427.869 407.645 427.929 407.55 428.01 407.475C428.717 406.8 431.537 407.572 431.859 407.657C431.893 407.67 431.922 407.692 431.945 407.72C431.968 407.749 431.982 407.782 431.987 407.818C431.989 407.854 431.981 407.89 431.964 407.922C431.947 407.954 431.922 407.981 431.891 408C431.293 408.361 430.657 408.652 429.993 408.868ZM428.471 407.636C428.386 407.653 428.308 407.694 428.246 407.754C428.215 407.784 428.194 407.822 428.184 407.864C428.175 407.906 428.178 407.949 428.192 407.99C428.203 408.114 428.247 408.234 428.318 408.338C428.39 408.441 428.487 408.524 428.599 408.579C429.554 408.712 430.522 408.47 431.301 407.904C430.385 407.63 429.423 407.539 428.471 407.636Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M431.858 408.022H431.762C430.883 407.829 428.953 406.618 428.888 405.718C428.882 405.576 428.923 405.436 429.004 405.32C429.085 405.204 429.203 405.118 429.339 405.075C429.466 405.014 429.605 404.983 429.746 404.983C429.887 404.983 430.026 405.014 430.154 405.075C431.226 405.525 431.955 407.668 431.987 407.764C432.002 407.794 432.01 407.827 432.01 407.861C432.01 407.894 432.002 407.927 431.987 407.957L431.858 408.022ZM429.553 405.397C429.525 405.388 429.495 405.388 429.467 405.397C429.253 405.493 429.253 405.6 429.253 405.654C429.253 406.179 430.572 407.154 431.494 407.518C431.247 406.897 430.679 405.686 430.003 405.375C429.852 405.326 429.688 405.334 429.542 405.397H429.553Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M432.138 406.789L440.586 404.239C440.732 404.194 440.889 404.202 441.03 404.261C441.171 404.319 441.287 404.426 441.358 404.561L444.574 410.882C444.65 411.041 444.69 411.214 444.692 411.39C444.695 411.566 444.659 411.74 444.588 411.901C444.517 412.061 444.411 412.205 444.28 412.321C444.148 412.438 443.992 412.524 443.824 412.575C440.865 413.411 439.385 413.647 435.665 414.793C433.381 415.479 426.016 419.186 422.907 420.15C419.797 421.114 418.532 418.072 419.754 417.386C425.212 414.354 429.618 409.886 431.044 407.636C431.296 407.232 431.684 406.932 432.138 406.789Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M366.222 420.707C365.556 420.773 364.888 420.602 364.335 420.225C364.211 420.114 364.117 419.973 364.062 419.816C364.008 419.658 363.995 419.489 364.024 419.325C364.031 419.221 364.065 419.12 364.124 419.034C364.182 418.947 364.262 418.878 364.357 418.832C365.332 418.296 368.42 419.904 368.763 420.086C368.799 420.102 368.828 420.13 368.845 420.165C368.863 420.2 368.868 420.24 368.86 420.279C368.851 420.317 368.831 420.352 368.803 420.379C368.774 420.406 368.738 420.423 368.699 420.429C367.884 420.601 367.055 420.695 366.222 420.707ZM364.871 419.089C364.75 419.084 364.629 419.106 364.517 419.154C364.482 419.176 364.452 419.206 364.43 419.241C364.408 419.276 364.394 419.316 364.389 419.357C364.374 419.466 364.384 419.577 364.42 419.681C364.455 419.785 364.514 419.88 364.592 419.957C365.053 420.386 366.351 420.45 368.088 420.161C367.085 419.621 365.997 419.259 364.871 419.089Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M368.667 420.439H368.592C367.659 420.011 365.858 418.296 366.04 417.429C366.04 417.225 366.244 416.957 366.759 416.914C366.949 416.881 367.145 416.892 367.33 416.946C367.516 417 367.687 417.095 367.831 417.225C368.785 418.05 368.903 420.161 368.903 420.257C368.903 420.289 368.895 420.32 368.88 420.348C368.865 420.376 368.844 420.4 368.817 420.418C368.771 420.442 368.718 420.45 368.667 420.439ZM366.887 417.225H366.78C366.437 417.225 366.415 417.396 366.405 417.439C366.298 417.964 367.477 419.304 368.453 419.882C368.407 418.997 368.08 418.148 367.52 417.461C367.341 417.318 367.116 417.245 366.887 417.257V417.225Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M369.546 419.336H378.123C378.277 419.333 378.426 419.386 378.544 419.484C378.662 419.583 378.741 419.72 378.766 419.871L380.01 426.857C380.04 427.029 380.032 427.206 379.985 427.375C379.939 427.544 379.856 427.7 379.743 427.833C379.629 427.966 379.487 428.072 379.328 428.144C379.168 428.216 378.995 428.252 378.82 428.25C375.732 428.196 371.315 428.014 367.38 428.014C362.834 428.014 358.889 428.261 353.56 428.261C350.344 428.261 349.583 425.046 350.944 424.714C357.152 423.364 362.17 423.225 367.627 419.946C368.2 419.574 368.863 419.363 369.546 419.336Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M397.486 133.843C396.103 139.586 395.235 146.7 399.084 150.536C399.084 150.536 396.521 156.364 385.843 156.364C376.086 156.364 381.222 150.536 381.222 150.536C387.655 149.014 387.708 141.086 386.797 136.607L397.486 133.843Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M369.471 402.075L369.46 411.439H377.319L377.33 402.075H369.471Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M432.138 388.746L424.622 391.028L428.889 399.525L436.416 397.254L432.138 388.746Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M414.79 157.714L404.712 163.5C404.712 163.5 415.283 188.143 414.243 192.129C412.817 197.486 412.099 208.425 409.901 215.529C410.77 216.504 413.707 218.25 414.887 218.207C419.175 209.636 426.165 195.011 425.758 190.05C424.836 178.714 414.79 157.714 414.79 157.714Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M409.901 215.529L402.996 218.379L409.922 224.132C409.922 224.132 415.883 221.443 414.79 216.386L409.901 215.529Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M399.137 224.55L405.666 229.446L409.922 224.132L402.996 218.379L399.137 224.55Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M413.074 152.314C420.386 153.803 426.326 179.903 426.326 179.903L409.858 187.821C409.858 187.821 404.218 175.243 401.731 166.007C399.136 156.321 405.226 150.718 413.074 152.314Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M407.2 161.293C404.134 158.078 405.528 170.871 406.3 179.378C406.954 181.071 407.586 182.593 408.133 183.889C412.561 177.482 411.489 165.793 407.2 161.293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M381.468 152.914C381.468 150.129 381.061 148.811 381.822 147.782C382.583 146.753 397.679 145.532 400.284 146.711C401.174 147.107 401.689 151.114 400.574 152.904C398.944 155.496 381.468 152.914 381.468 152.914Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M381.468 152.914C381.468 150.129 381.061 148.811 381.822 147.782C382.583 146.753 397.679 145.532 400.284 146.711C401.174 147.107 401.689 151.114 400.574 152.904C398.944 155.496 381.468 152.914 381.468 152.914Z",
			fill: "#FDD400"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M369.042 152.722C369.042 152.722 358.728 176.422 365.59 220.564H407.607C408.175 214.136 405.463 182.679 413.075 152.314C408.455 151.417 403.781 150.823 399.083 150.536C393.134 150.193 387.171 150.193 381.222 150.536C377.111 150.95 373.04 151.681 369.042 152.722Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M375.035 163.736L364.625 159.547C364.625 159.547 350.558 183.418 347.62 185.422C340.812 181.693 338.529 183.204 333.232 179.293C331.892 179.432 329.801 181.297 329.094 182.25C333.382 190.5 347.631 200.711 354.675 194.486C363.392 186.782 375.035 163.736 375.035 163.736Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M376.344 160.907C374.779 156.879 371.498 155.197 367.949 155.786C366.384 160.725 363.66 171.579 363.274 187.929L367.349 188.85C367.349 188.85 379.035 167.797 376.344 160.907Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M378.134 158.09C380.471 165.118 366.147 185.797 366.147 185.797L350.815 177.225C353.466 170.775 356.779 164.618 360.701 158.85C366.63 150.611 375.571 150.386 378.134 158.09Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M333.49 179.518L326.489 175.479L322.394 183.622C325.223 184.553 328.185 185.02 331.164 185.004L333.49 179.518Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M323.036 175.479L318.029 180.236L322.393 183.622L326.489 175.479H323.036Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M380.074 125.582C380.01 126.215 379.624 126.654 379.217 126.654C378.809 126.654 378.52 126.097 378.584 125.465C378.648 124.832 379.034 124.393 379.453 124.393C379.871 124.393 380.139 124.95 380.074 125.582Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M380.632 125.636C379.683 127.529 378.486 129.287 377.072 130.864C377.479 131.2 377.956 131.441 378.468 131.569C378.98 131.697 379.514 131.709 380.031 131.604L380.632 125.636Z",
			fill: "#ED893E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M379.324 123.397L379.163 123.332C379.123 123.304 379.089 123.269 379.063 123.228C379.037 123.187 379.02 123.141 379.012 123.093C379.004 123.045 379.005 122.996 379.017 122.949C379.028 122.902 379.049 122.857 379.077 122.818C379.414 122.313 379.863 121.892 380.389 121.589C380.916 121.286 381.505 121.109 382.112 121.072C382.159 121.073 382.207 121.084 382.25 121.103C382.294 121.123 382.333 121.151 382.366 121.186C382.399 121.221 382.425 121.262 382.442 121.306C382.459 121.351 382.467 121.399 382.465 121.447C382.46 121.546 382.417 121.64 382.346 121.709C382.274 121.779 382.179 121.819 382.079 121.822C381.605 121.861 381.147 122.009 380.74 122.254C380.332 122.499 379.987 122.835 379.731 123.236C379.687 123.3 379.624 123.349 379.552 123.377C379.479 123.406 379.4 123.413 379.324 123.397Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M401.421 125.036C400.145 132.771 399.802 137.346 395.481 141.107C394.109 142.348 392.421 143.187 390.603 143.532C388.785 143.877 386.907 143.715 385.175 143.063C383.443 142.41 381.925 141.294 380.787 139.836C379.648 138.377 378.935 136.634 378.723 134.796C377.769 127.725 379.999 116.271 387.901 113.614C389.589 112.995 391.412 112.834 393.183 113.148C394.954 113.461 396.61 114.237 397.983 115.397C399.357 116.558 400.398 118.061 401.002 119.753C401.606 121.446 401.75 123.269 401.421 125.036Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M385.285 128.368C383.677 123.279 381.586 115.415 387.301 112.5C393.015 109.586 397.518 113.636 403.747 117.386C410.77 121.608 406.481 135 398.011 138.15C390.903 140.797 383.966 135.483 385.285 128.368Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M385.907 118.929C380.868 120.289 377.394 117.054 379.881 113.325C383.034 108.579 395.428 109.821 400.07 114.954C404.712 120.086 389.402 122.539 385.907 118.929Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M387.826 115.179C381.672 114.043 379.153 109.029 384.31 105.921C389.177 102.996 402.858 108.064 405.141 116.143C407.425 124.222 389.692 120.911 387.826 115.179Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M404.229 119.025C405.162 118.275 408.872 117.204 409.29 121.35C407.937 119.993 406.141 119.168 404.229 119.025Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M406.889 113.861C407.629 114.804 408.679 118.511 404.52 118.907C405.887 117.562 406.727 115.772 406.889 113.861Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M389.713 128.014C389.153 129.686 387.976 131.081 386.422 131.914C384.363 132.986 382.937 131.293 383.205 129.107C383.43 127.147 384.771 124.211 386.99 124.039C389.209 123.868 390.389 125.968 389.713 128.014Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M380.492 220.564C380.492 220.564 386.764 280.564 390.667 303.064C394.955 327.707 424.975 398.85 424.975 398.85L438.753 394.693C438.753 394.693 417.31 329.282 415.283 304.918C413.139 278.464 407.65 220.596 407.65 220.596L380.492 220.564Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M390.152 241.543C389.53 240.6 388.941 240.279 388.372 240.472H388.265C388.134 240.524 388.011 240.597 387.901 240.686C387.786 240.781 387.678 240.885 387.579 240.997C387.515 241.061 387.461 241.136 387.397 241.211C387.332 241.286 387.236 241.436 387.15 241.564C386.955 241.878 386.78 242.204 386.625 242.539C386.539 242.743 386.442 242.957 386.357 243.172C386.271 243.386 386.142 243.718 386.035 244.018C385.928 244.318 385.756 244.832 385.628 245.272C385.628 245.389 385.553 245.497 385.52 245.614C385.488 245.732 385.381 246.107 385.306 246.354L385.145 246.997C385.027 247.425 384.92 247.854 384.813 248.304C384.706 248.754 384.598 249.279 384.491 249.782C384.491 249.954 384.416 250.136 384.373 250.307C384.245 250.95 384.116 251.614 383.987 252.279C385.713 267.214 387.783 284.336 389.584 296.282C389.713 295.897 389.841 295.489 389.97 295.05C390.523 293.061 390.97 291.044 391.31 289.007C393.98 273.611 394.183 247.682 390.152 241.543Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M365.59 220.564C365.59 220.564 361.923 279.257 361.719 303.203C361.505 328.103 366.619 409.628 366.619 409.628H379.925C379.925 409.628 383.945 329.561 385.618 305.1C387.43 278.443 393.208 220.564 393.208 220.564H365.59Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M380.986 405.557C381.039 405.557 380.793 409.896 380.793 409.896H365.45L365.021 405.021L380.986 405.557Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M437.659 389.807C438.002 390.482 439.46 394.714 439.46 394.714L424.354 399.289L421.877 395.218L437.659 389.807Z",
			fill: "#0066CC"
		})
	]
});
const ForwardRef = forwardRef(SvgStep6);
export default ForwardRef;
